export interface Category {
  id: number;
  slug: string;
  name: string;
  icon: string;
  description: string;
}

export const categories: Category[] = [
  {
    id: 1,
    slug: 'yule-chigua',
    name: '娱乐吃瓜',
    icon: 'ri-movie-2-line',
    description: '娱乐圈最新最全的吃瓜爆料，影视综艺幕后故事',
  },
  {
    id: 2,
    slug: 'mingxing-bagua',
    name: '明星八卦',
    icon: 'ri-star-line',
    description: '明星私生活、恋情曝光、人设崩塌等八卦资讯',
  },
  {
    id: 3,
    slug: 'shehui-redian',
    name: '社会热点',
    icon: 'ri-fire-line',
    description: '社会热点事件、争议话题、全民围观的瓜料',
  },
  {
    id: 4,
    slug: 'zuixin-baoliao',
    name: '最新爆料',
    icon: 'ri-flashlight-line',
    description: '独家最新爆料，第一时间掌握劲爆内幕',
  },
  {
    id: 5,
    slug: 'wanghong-dongtai',
    name: '网红动态',
    icon: 'ri-live-line',
    description: '网红圈最新动态、主播八卦、短视频达人热点',
  },
  {
    id: 6,
    slug: 'yingshi-zongyi',
    name: '影视综艺',
    icon: 'ri-tv-2-line',
    description: '影视剧、综艺节目相关爆料与幕后花絮',
  },
];

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((c) => c.slug === slug);
}

export function getCategoryById(id: number): Category | undefined {
  return categories.find((c) => c.id === id);
}